/** Home hero: rotating headline word timing and copy */
export const HERO_ROTATE_INTERVAL_MS = 4000

export const HERO_ROTATE_WORDS_EN = ['Impactful', 'Intelligent', 'Scalable']

export const HERO_ROTATE_WORDS_PT = ['Impactantes', 'Inteligentes', 'Escaláveis']

/** Service lines inside hero pillar cards (expanded scroll state) */
export const HOME_PILLAR_SERVICE_LINES = {
  'app-dev': {
    en: [
      'API & Microservices',
      'Web development',
      'Mobile development',
      'CMS-based development',
      'UX/UI',
    ],
    pt: [
      'API & Microserviços',
      'Desenvolvimento web',
      'Desenvolvimento mobile',
      'Desenvolvimento com CMS',
      'UX/UI',
    ],
  },
  'data-ai': {
    en: [
      'Database creation and management',
      'Business Intelligence & Reporting',
      'AI integrations',
      'RAG systems',
    ],
    pt: [
      'Criação e gestão de bases de dados',
      'Business Intelligence & Reporting',
      'Integrações de IA',
      'Sistemas RAG',
    ],
  },
  cloud: {
    en: [
      'Cloud development',
      'Cloud migration & optimization',
      'DevOps',
      'GCP Partners',
    ],
    pt: [
      'Desenvolvimento cloud',
      'Migração e otimização cloud',
      'DevOps',
      'Parceiros GCP',
    ],
  },
  cyber: {
    en: [
      'Threat hunting',
      'Vulnerability management',
      'IAM',
      'DORA & NIS2 Consulting',
    ],
    pt: [
      'Threat hunting',
      'Gestão de vulnerabilidades',
      'IAM',
      'Consultoria DORA e NIS2',
    ],
  },
}
